import React, { useEffect, useState } from "react";
import { getjobWorkersInfo } from "../../../../../api/apiCall";
import { useAuth } from "../../../../../auth/auth";
import styles from "./WorkersTable.module.css";
import { toast } from "react-toastify";

const WorkersTable = ({ id }: any) => {
    const { state } = useAuth();
    const [workers, setWorkers] = useState<any>([]);

    const getWorkers = async () => {
        try {
            const response = await getjobWorkersInfo(state.user?.token, id);
            if (response && Array.isArray(response)) {
                setWorkers(response);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getWorkers();
    }, []);

    const copyColumnToClipboard = (columnName: string) => {
        const columnData = workers.map((worker: any) => worker[columnName]).join("\n");

        navigator.clipboard.writeText(columnData)
            .then(() => toast.info(`Copied to clipboard`))
            .catch(err => console.error("Failed to copy:", err));
    };

    return (
        <div className={styles.tableContainer}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th onClick={() => copyColumnToClipboard('workRole')}>ROLE</th>
                        <th onClick={() => copyColumnToClipboard('fullName')}>NAME</th>
                        <th onClick={() => copyColumnToClipboard('pts')}>PTS</th>
                        <th onClick={() => copyColumnToClipboard('phoneNumber')}>PHONE NUMBER</th>
                        <th onClick={() => copyColumnToClipboard('email')}>EMAIL</th>
                        <th onClick={() => copyColumnToClipboard('postCode')}>POST CODE</th>
                    </tr>
                </thead>
                <tbody>
                    {workers.map((worker: any, index: number) => (
                        <tr key={index}>
                            <td>{worker.workRole}</td>
                            <td>{worker.fullName}</td>
                            <td>{worker.pts}</td>
                            <td>{worker.phoneNumber}</td>
                            <td>{worker.email}</td>
                            <td>{worker.postCode}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default WorkersTable;
